<div class="modal-body">
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true" class="material-symbols-outlined">close</span>
  </button>
  <img class="pheno-browser-fullscreen-image" src="{{ imageUrl }}" />
</div>
